<template>
    <v-app>
        <v-content>
            <v-container class="fill-height" :style="configs.stylebgcolor" fluid>
                <v-row class=".d-none .d-sm-flex" align="center" justify="center">
                    <img v-bind:src="configs.logo" width="200" alt="John" />
                </v-row>
                <v-row align="center" justify="center">
                    
                    <v-col cols="12" sm="8" md="4">
                        <v-alert type="success" v-show="confirm.sended">
                            {{confirm.text}}
                        </v-alert>
                        <v-card class="elevation-12">
                            
                            <v-toolbar v-bind:color="configs.color" dark flat>
                                <v-toolbar-title>Plano Prime - {{ configs.sistema }}</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <p class="title">Preencha os dados abaixo:</p>
                                <v-form>
                                    <v-text-field
                                        v-model="form.empresa"
                                        outlined
                                        dense
                                        label="Empresa"
                                        name="empresa"
                                        type="text"
                                    />
                                    <v-text-field
                                        v-model="form.cnpj"
                                        v-mask="masks.cnpj"
                                        outlined
                                        dense
                                        label="CNPJ"
                                        name="cnpj"
                                        type="text"
                                    />
                                    <v-text-field
                                        v-model="form.nome"
                                        outlined
                                        dense
                                        label="Nome para Contato"
                                        name="nome"
                                        type="text"
                                    />
                                    <v-text-field
                                        v-model="form.celular"
                                        v-mask="masks.celular"
                                        outlined
                                        dense
                                        label="Celular para Contato"
                                        name="celular"
                                        type="tel"
                                    />
                                    <v-text-field
                                        v-model="form.email"
                                        outlined
                                        dense
                                        label="E-mail"
                                        name="email"
                                        type="email"
                                    />
                                    <!-- <v-row class="mb-n4 mt-n4">
                                        <v-col cols="12" sm="12" md="6">
                                            
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6">
                                            
                                        </v-col>
                                    </v-row> -->
                                    <v-row class="mb-n4 mt-n6">
                                        <v-col cols="12" sm="12" md="6">
                                            <v-text-field
                                                v-model="form.cidade"
                                                outlined
                                                dense
                                                label="Cidade"
                                                name="cidade"
                                                type="text"
                                            />
                                        </v-col>
                                        <v-col  cols="12" sm="12" md="6">
                                            <v-select
                                                :items="estados"
                                                v-model="form.estado"
                                                outlined
                                                dense
                                                label="Estado"
                                                name="estado"
                                                type="text"
                                            />
                                        </v-col>
                                    </v-row>
                                    <!-- <v-card class="mx-auto" outlined>
                                        <v-card-title>Interesse em:</v-card-title>
                                        <v-card-text class="d-flex flex-row mt-n2 mb-n2">
                                            <v-row class="mb-n4 mt-n6">
                                                <v-col  cols="12" sm="12" md="6" lg="4">
                                                    <v-checkbox v-model="form.tipos" label="Serviços" value="Serviços"></v-checkbox>
                                                </v-col>
                                                <v-col  cols="12" sm="12" md="6" lg="4">
                                                    <v-checkbox v-model="form.tipos" label="Produtos" value="Produtos"></v-checkbox>
                                                </v-col>
                                                <v-col  cols="12" sm="12" md="6" lg="4">
                                                    <v-checkbox v-model="form.tipos" label="Salão Parceiro" value="Salão Parceiro"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card> -->
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn :disabled="loading" v-on:click="enviaFormulario()" dark v-bind:color="configs.color">Enviar </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <v-snackbar v-model="snackbar.show">
                {{ snackbar.text }}
                <v-btn
                    color="red"
                    snackbar.text
                    @click="snackbar.show = false;snackbar.text = ''">
                    Fechar
                </v-btn>
            </v-snackbar>
        </v-content>
    </v-app>
</template>

<script>

export default {
  name: "Formulario",
  props: {
    configs: Object
  },
  data() {
    return {
        form: {
            nome: "",
            empresa: "",
            cnpj: "",
            email: "",
            celular: "",
            cidade: "",
            estado: "",
            tipos: []
        },
        snackbar: {
            text: "",
            show: false
        },
        loading: false,
        confirm : {
            sended: false,
            text: "Solicitação enviada com sucesso. Aguarde o contato da nossa equipe comercial."
        },
        estados: [
            "Acre (AC)",
            "Alagoas (AL)",
            "Amapá (AP)",
            "Amazonas (AM)",
            "Bahia (BA)",
            "Ceará (CE)",
            "Distrito Federal (DF)",
            "Espírito Santo (ES)",
            "Goiás (GO)",
            "Maranhão (MA)",
            "Mato Grosso (MT)",
            "Mato Grosso do Sul (MS)",
            "Minas Gerais (MG)",
            "Pará (PA)",
            "Paraíba (PB)",
            "Paraná (PR)",
            "Pernambuco (PE)",
            "Piauí (PI)",
            "Rio de Janeiro (RJ)",
            "Rio Grande do Norte (RN)",
            "Rio Grande do Sul (RS)",
            "Rondônia (RO)",
            "Roraima (RR)",
            "Santa Catarina (SC)",
            "São Paulo (SP)",
            "Sergipe (SE)",
            "Tocantins (TO)",
        ],
        color: "",
        sistema: "",
        masks: {
            cnpj: "##.###.###/####-##",
            celular: "(##) #####-####"
        }
    };
  },
    methods: {
        validaCNPJ(cnpj) {
            cnpj = cnpj.replace(/[^\d]+/g,'');
 
            if(cnpj == '') return false;
            
            if (cnpj.length != 14)
                return false;
        
            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" || 
                cnpj == "11111111111111" || 
                cnpj == "22222222222222" || 
                cnpj == "33333333333333" || 
                cnpj == "44444444444444" || 
                cnpj == "55555555555555" || 
                cnpj == "66666666666666" || 
                cnpj == "77777777777777" || 
                cnpj == "88888888888888" || 
                cnpj == "99999999999999")
                return false;
                
            // Valida DVs
            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0,tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;
                
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;
                
            return true;
        },
        enviaFormulario() {
            if (this.form.empresa == "") {
                this.snackbar.text = "Informe a Empresa";
                this.snackbar.show = true;
                return;
            }

            if (this.form.cnpj == "") {
                this.snackbar.text = "Informe o CNPJ";
                this.snackbar.show = true;
                return;
            }

            if (!this.validaCNPJ(this.form.cnpj)){
                this.snackbar.text = "Informe o CNPJ válido";
                this.snackbar.show = true;
                return;
            }

            if (this.form.nome == "") {
                this.snackbar.text = "Informe o Nome para Contato";
                this.snackbar.show = true;
                return;
            }

            if (this.form.celular == "") {
                this.snackbar.text = "Informe o Telefone para Contato";
                this.snackbar.show = true;
                return;
            }

            if (this.form.email == "") {
                this.snackbar.text = "Informe o Email";
                this.snackbar.show = true;
                return;
            }

            if (this.form.cidade == "") {
                this.snackbar.text = "Informe a Cidade";
                this.snackbar.show = true;
                return;
            }

            if (this.form.estado == "") {
                this.snackbar.text = "Informe o Estado";
                this.snackbar.show = true;
                return;
            }

            // if (this.form.tipos.length == 0) {
            //     this.snackbar.text = "Selecione pelo menos um interesse.";
            //     this.snackbar.show = true;
            //     return;
            // }

            let htmlMensagem = `
                <html>
                    <body>
                        <h2> ${this.configs.sistema} - Interesse no Plano Prime </h3>
                        <p> <strong>Empresa:</strong> ${this.form.empresa} </p>
                        <p> <strong>CNPJ:</strong> ${this.form.cnpj} </p>
                        <p> <strong>Nome do Contato:</strong> ${this.form.nome} </p>
                        <p> <strong>Celular do Contato:</strong> ${this.form.celular} </p>
                        <p> <strong>E-mail:</strong> ${this.form.email} </p>
                        <p> <strong>Cidade:</strong> ${this.form.cidade} </p>
                        <p> <strong>Estado:</strong> ${this.form.estado} </p>
                    </body>
                </html>
            `;
            
            let datapost = {
                emailcliente: 'contato@starapp.com.br',
                emailtitulo: this.configs.sistema + ' - Interesse no Plano Prime',
                emailmensagem: htmlMensagem

            };

            var alertSended = this.confirm;
            var formSended = this.form;
            
            var url = 'https://ws.appbeleza.com.br/servicemail.php';
            
            var progressLoading = this.loading;
            progressLoading = true;
            fetch(url, {
                method: 'post',
                headers: {
                    "Content-type": "application/x-www-form-urlencoded"
                },
                body: Object.keys(datapost).map(key => `${key}=${encodeURIComponent(datapost[key])}`).join('&')
            })
            .then(() => {
                alertSended.sended = true;
                formSended.nome = "";
                formSended.empresa = "";
                formSended.cnpj = "";
                formSended.email = "";
                formSended.celular = "";
                formSended.cidade = "";
                formSended.estado = "";
                formSended.tipos = [];
                progressLoading = false;
            })
            .catch(() => {
                alert("Falha ao enviar o e-mail");
            });
        
        }
    }
};
</script>